<script lang='ts'>
import type { PropType, SetupContext } from 'vue'
import type { PaginationModel } from '../types/page'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'MsPagination',
  props: {
    pagination: {
      type: Object as PropType<PaginationModel>,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-page'],
  setup(props, ctx: SetupContext) {
    function changePage(page: number) {
      ctx.emit('change-page', page)
    }

    const paginationVisible = computed(() => {
      // 初次渲染时，如果page不是第一页，此时total是0，会强制回到第一页，此处判断一下total是0先不渲染
      return props.pagination?.total
    })
    return {
      changePage,
      paginationVisible,
    }
  },
})
</script>

<template>
  <div v-if="paginationVisible" class="page-selector">
    <slot />
    <div class="right">
      <el-pagination
        :current-page="pagination.page" :page-size="pagination.limit"
        :small="isSmall"
        :total="pagination.total" background @current-change="changePage"
      />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.page-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .right {
    width: 0;
    flex: 1;
    justify-content: flex-end;
    display: flex;
    align-items: center;
  }
}
</style>
